



































import MainButton from '@/main-components/common/MainButton.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { MainButton },
})
export default class SignupBanner extends Vue {
  emailInput = '';

  signupSubmit() {
    this.$router.push({
      path: `/signup?email=${this.emailInput}`,
    });
  }
}
